<script setup lang="ts">
defineProps<{
    customerId: string|number
}>();
</script>

<template>
  <router-link :to="{name: 'customer.drug-interactions', params: {customerId}}">
    <div
      class="bg-white px-4 py-2 h-full shadow rounded-md sm:rounded-lg sm:overflow-hidden min-w-max flex flex-1 flex-row items-center justify-between border-2 border-transparent hover:border-primary/50"
    >
      <div class="flex flex-row items-center">
        <img
          src="@/assets/images/logos/logo-vidal.png"
          class="cursor-pointer mr-5 h-4"
          alt="Survey icon"
        >
        <h2 class="text-primary">
          Analyse pharmaceutique
        </h2>
      </div>
      <p class="text-2xl text-primary">
        >
      </p>
    </div>
  </router-link>
</template>

<style scoped>

</style>
